import { Button, HStack, Heading, Image, Input, Stack, Text, VStack } from '@chakra-ui/react';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { backendurl } from '../path';
import { FaMailBulk, FaMoneyBill, FaPhone } from 'react-icons/fa';
import Payslip from './Payslip';

const StudentInfo = () => {
    const {id}=  useParams();
    const [studentdata,setdata]=useState(null);
 

    useEffect(() => {
const getteacher=async()=>{
const response = await axios.post(`${backendurl}/get-student`,{"_id":id});
setdata(response.data);
console.log(response.data)
}   
getteacher(); 
    }, [id])



  return (
    <Stack direction={['column','row']} w={'full'} mt={['20vh','25vh']}>
        <VStack  w={'full'}>
            <HStack justifyContent={'center'} spacing={'4'} w={'full'}>
            <Image src={studentdata?.simg} h={32} w={32} rounded={'full'}/>
            <Heading textTransform={'uppercase'}>{studentdata?.name}</Heading>
            </HStack>
            <HStack w="full" justifyContent={'center'} alignItems={'center'}>
          <HStack>
          <Text fontSize={'xl'} fontWeight={'bolder'}>Class:</Text>
             <Text>{studentdata?.classname}</Text>
            </HStack> 

            <HStack>
            <Text fontSize={'xl'} fontWeight={'bolder'}>Father:</Text>
             <Text>{studentdata?.fathername}</Text>
            </HStack> 

            <HStack>
            <Text fontSize={'xl'} fontWeight={'bolder'}>Mother:</Text>
             <Text>{studentdata?.mothername}</Text>
            </HStack> 
            </HStack>

            <HStack w={'full'} justifyContent={'space-around'}>

            <HStack >
            <Text fontSize={'xl'} fontWeight={'bolder'}>Address:</Text>
             <Text>{studentdata?.address}</Text>
            </HStack> 

            <HStack >
            <Text fontSize={'xl'} fontWeight={'bolder'}>Phone:</Text>
             <Text>{studentdata?.phone}</Text>
            </HStack> 

            </HStack>
            <Text fontWeight={'bolder'} mt={'4'}>Fee paid details</Text>
            <VStack overflowY={'scroll'} maxH={'300px'}>
                
                    {studentdata?.feepaid?.map((det,ind)=>(
                        <HStack>
                        <Input value={det.amount} readOnly/>
                    <Input value={det.month} type="month" readOnly/>
                </HStack>
                    ))}
                    
                    
            </VStack>
        </VStack>
        <VStack w='full' px={'8'}>
<Payslip id={id}/>
        </VStack>
    </Stack>
  )
}

export default StudentInfo
